export default "__VITE_ASSET__jItRnzg6__"